import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { Range, rangePath } from '../data/mockData';

/**
 * One card for either discovery layer.
 * `kind` drives the label so an official Collection never reads as a
 * Choose Your Story range (and vice versa).
 */
export function RangeCard({
  range,
  index = 0,
  size = 'default'
}: {
  range: Range;
  index?: number;
  size?: 'default' | 'tall';
}) {
  const isStory = range.kind === 'story';
  return <motion.article initial={{
    opacity: 0,
    y: 28
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.55,
    delay: Math.min(index * 0.06, 0.3),
    ease: [0.23, 1, 0.32, 1]
  }} className="group" data-id="element-217" data-mp="2wr0ak6i7w62y">
      <Link to={rangePath(range)} className="block" data-id="element-218" data-mp="gz3zkfvch27d">
        <div className={`relative overflow-hidden rounded-4xl ${size === 'tall' ? 'aspect-[3/4]' : 'aspect-[4/5]'}`} data-id="element-219" data-mp="lxxco76pyr70">
          <img src={range.image} alt={range.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]" data-id="element-220" data-mp="1l100t2nq1g9c" />
          <div className="absolute inset-0 bg-gradient-to-t from-coffee/85 via-coffee/20 to-transparent" data-id="element-221" data-mp="1txhhsmiro8d0" />

          <span className="type-eyebrow absolute left-5 top-5 rounded-full px-3.5 py-1.5 text-[9px]" style={isStory ? {
          backgroundColor: '#432C47',
          color: '#F3EEE7'
        } : {
          backgroundColor: '#F3EEE7',
          color: '#3B302F'
        }} data-id="element-222" data-mp="124h1t66mt8qi">
            {isStory ? 'Choose Your Story' : 'Collection'}
          </span>

          <div className="absolute inset-x-0 bottom-0 p-6 md:p-7" data-id="element-223" data-mp="2mkbwt3wtefj3">
            <p className="type-eyebrow mb-2 text-[9px] text-paper/70" data-id="element-224" data-mp="2mir4lkxz38oe">
              {range.series}
            </p>
            <h3 className="type-display text-3xl text-paper md:text-4xl" data-id="element-225" data-mp="2hnbpkpo8b6qe">
              {range.name}
            </h3>
            <p className="type-body mt-2 max-w-[34ch] text-sm text-paper/75" data-id="element-226" data-mp="1k6w4cd8k4t8g">
              {range.tagline}
            </p>
            <span className="type-cta mt-5 inline-flex items-center gap-2 text-[10px] text-paper" data-id="element-227" data-mp="1o89daw6y5cjl">
              {isStory ? 'Read the story' : 'Explore'}
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-1" strokeWidth={1.5} data-id="element-228" data-mp="1t5hv2vo6nekb" />
            </span>
          </div>
        </div>
      </Link>
    </motion.article>;
}